import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { UtilityService } from '@eforall/common';
import { DialogService, GridContentWidget, PageTabsMainTabGridSize } from '@eforall/dashboard';
import { BaseDropout } from '@interfaces';
import { AppService, DomainDataService } from '../../../../../../services';
import { DeliveryAreaService } from '../../../../delivery-area.service';
import { DeliveryOverviewService } from '../../../delivery-overview.service';
import { getSetup } from './grid/get-setup';

export interface AccVentureDropout extends BaseDropout {
	accVentureId: number,
	ventureName: string,
	accTeamId: number,
	accId: number,
	accName: string,
	dropoutReason: string,
	facilitatorName: string,
}


@Component({
	selector: 'delivery-venture-dropouts-view-part',
	standalone: true,
	imports: [GridContentWidget],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './venture-dropouts-view.part.html',
})
export class DeliveryVentureDropoutsViewPart {

	private readonly util = inject(UtilityService);
	private readonly app = inject(AppService);
	private readonly dialogService = inject(DialogService);
	private readonly domain = inject(DomainDataService);
	private readonly pageService = inject(DeliveryOverviewService);
	private readonly areaService = inject(DeliveryAreaService);

	public setup = computed(() => getSetup(this.util, this.dialogService, this.areaService));

	public pageTabsGridSize = computed<PageTabsMainTabGridSize | undefined>(() => {
		if (this.pageService.layout()) return { layout: this.pageService.layout()!, viewSelector: true };
		return undefined;
	});

	public ventureDropouts = computed<AccVentureDropout[]>(() => {
		const data = this.areaService.deliveryData();

		if (!data) return [];

		const accById = this.util.array.toMap(data.accelerators, a => a.accId);

		return data.allVentures.filter(v => !!v.dropout).map(v => {
			return {
				...v.dropout!, //always defined because of the filter above
				dropoutReason: this.domain.data().dropoutReasonsMap[v.dropout!.dropoutReasonId]?.name ?? '',
				accVentureId: v.accVentureId,
				ventureName: v.ventureName,
				accTeamId: v.accTeamId,
				accId: v.accId,
				accName: accById[v.accId]?.name ?? '',
				facilitatorName: this.app.getStaffNameById(accById[v.accId]?.facilitatorStaffId) ?? '',
			};
		});
	});
}